export default __webpack_public_path__ + "static/lesson_video-3143266b83795160a5b01a94ec63a477.mp4";